export default "__VITE_ASSET__v0S2a8$g__"